import { toast } from 'sonner';
import { Link2, Twitter, Linkedin } from 'lucide-react';

interface ShareButtonsProps {
  url: string;
  title: string;
}

export default function ShareButtons({ url, title }: ShareButtonsProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied');
    } catch {
      toast.error('Failed to copy link');
    }
  };

  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  return (
    <div className="flex gap-2 items-center mt-3">
      <span className="text-xs text-muted">Share:</span>
      <button
        onClick={handleCopy}
        className="btn-terminal text-xs flex items-center gap-1 py-0.5 px-2"
        aria-label="Copy link"
      >
        <Link2 size={12} />
        Link
      </button>
      <a
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-terminal text-xs flex items-center gap-1 py-0.5 px-2 no-underline"
        aria-label="Share on Twitter"
      >
        <Twitter size={12} />
        Twitter
      </a>
      <a
        href={linkedinUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-terminal text-xs flex items-center gap-1 py-0.5 px-2 no-underline"
        aria-label="Share on LinkedIn"
      >
        <Linkedin size={12} />
        LinkedIn
      </a>
    </div>
  );
}
